module.exports = __webpack_public_path__ + "static/media/multas_pagadas.91554649.svg";